import { createContext, useState, ReactNode, useCallback } from "react";

export interface PageStatusContextType {
  firstVisit: boolean;
  setVisited: () => void;
}

export const PageStatusContext = createContext<
  PageStatusContextType | undefined
>(undefined);

export const PageStatusProvider = ({ children }: { children: ReactNode }) => {
  const [firstVisit, setFirstVisit] = useState(true);

  const setVisited = useCallback(() => setFirstVisit(false), []);

  return (
    <PageStatusContext.Provider value={{ firstVisit, setVisited }}>
      {children}
    </PageStatusContext.Provider>
  );
};
